import { Component, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

import { getInheritableTypeFromList } from '../is-inheritable/utils';
import { InheritableType } from '../is-inheritable/is-inheritable.model';
import { EditorBookingItem } from '../editor-booking-item/editor-booking-item.model';
import { EditorBookingItemEditStore } from '../editor-booking-item-edit/editor-booking-item-edit.store';
import { EditorDialogStore } from '../editor-dialog/editor-dialog.store';


@Component({
    // tslint:disable-next-line:component-selector
    selector: '[eas-editor-booking-item-metadata-list]',
    templateUrl: './editor-booking-item-metadata-list.component.html',
    styleUrls: ['./editor-booking-item-metadata-list.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemMetadataListComponent implements OnChanges, OnInit {

  @Input() item: EditorBookingItem;

  inheritableType: InheritableType;

  constructor(
    private itemEditStore: EditorBookingItemEditStore,
    private itemDialogStore: EditorDialogStore
  ) {

  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.item) {
      this.inheritableType = this.getInheritableType();
    }
  }

  onEdit() {
    this.itemEditStore.startEditing(this.item.id, { name: 'metadataList', value: null });
    this.itemDialogStore.editBookingItem();
    return false;
  }

  getInheritableType() {
    return getInheritableTypeFromList(this.item.metadataList.map(metadata => metadata.inheritableType));
  }

  get cssClassName(): string {
    switch (this.inheritableType) {
      case 'empty':
        return '';
      case 'set':
      case 'inherited':
      case 'inherited-overridden':
      case 'overridden':
        return 'option_row--set';
    }
  }
}
